export const DICTIONARY_API_LOCATIONS_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "settings/locations",
  FILTER_PATH: "/filter",
  BASIC_INFO: "/basic-info",
  UNKNOWN_INFO: "/unknown",
  REPLACE: "/replace",
};
